import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonModule } from '@angular/common';
import { AuthService } from '../auth.service';
import { StorageService } from '../../../common/services/storage.service';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [FormsModule, CommonModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent {
  numeroCredencial = '';
  documentoNumero = '';
  redirectTo = '/home';
  rememberMe = false;
  isLoading = false;
  errorMessage: string | null = null;
  loginFailed: boolean = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService,
    private storageService: StorageService
  ) { }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      if (params['redirectTo']) {
        this.redirectTo = params['redirectTo'];
      }
    });
    this.numeroCredencial = localStorage.getItem('numeroCredencial') || '';
    this.documentoNumero = localStorage.getItem('documentoNumero') || '';

  }

login() {
  this.isLoading = true;
  this.errorMessage = null;
  this.loginFailed = false;

  this.authService.login(this.numeroCredencial, this.documentoNumero).subscribe({
    next: (response) => {
      this.isLoading = false;

      const result = response?.Result;

      if (result?.AccessToken) {
        this.storageService.token = result.AccessToken;
        this.storageService.refreshToken = result.RefreshToken;
        this.storageService.documentNumber = result.DocumentoNumero;

        if (this.rememberMe) {
          localStorage.setItem('numeroCredencial', this.numeroCredencial);
          localStorage.setItem('documentoNumero', this.documentoNumero);
        } else {
          localStorage.removeItem('numeroCredencial');
          localStorage.removeItem('documentoNumero');
        }

        this.router.navigate([this.redirectTo]);
      } else {
        this.loginFailed = true;
        this.errorMessage = 'No se recibió token de autenticación.';
      }
    },
    error: (err) => {
      this.isLoading = false;
      this.loginFailed = true;

      const errorList = err?.error?.ErrorList;
      if (Array.isArray(errorList) && errorList.length > 0) {
        this.errorMessage = errorList.join(' ');
      } else {
        this.errorMessage =
          err?.error?.descripcion ||
          'Error al conectar con el servidor. Intente más tarde.';
      }
    }
  });
}
}
